export const environment = {
  production: true,
  host: "https://andriasmart-be-stage.fivelab.it",
  basicUsername: 'APP',
  oneSignalAppId: 'f2b5ed12-7b27-4f1d-8b21-27a9758b72c3',
  basicPassword: '0j9hX6ba8ieV9Ma46CVtTaOx',
  appDeepLink: 'https://andriasmart.fivelab.it',
  reverseProxy: 'https://proxy.fivelab.it',
  quiAffittiUrl: 'https://quiaffitti.it/?search_term=&status=&llocs=',
  googleClientId: '689668954648-tkc7eklnhaimvfmsp83ghvbuvt10u80t.apps.googleusercontent.com',
  googleClientIdAndroid: '689668954648-2sajrms53nqj4sre9msr7k42ru81ra52.apps.googleusercontent.com',
  googleClientIdIos: 'com.googleusercontent.apps.689668954648-tkc7eklnhaimvfmsp83ghvbuvt10u80t',
  facebookAppId: '1344232050616880',
  facebookClientToken: '8fc0bcee5382f4a2058d0756118147ba',
  fontePapaCatId: 55,
  luoghiImperdibiliCatId: 61,
  mangiaEbeviCatId: 68,
  fontePapaTemplate: 43,
  debugFirebase: true,
  config: {
    MAX_EVENT_DESCRIPTION_LENGTH: 300,
    MAX_NEWS_DESCRIPTION_LENGTH: 300

  }
};
